import React, { useReducer, useEffect, useState } from 'react';
import * as actions from '../../../actions/dashboard';
import dashboardReducer from '../../../reducers/dashboard';
import SafetyAlert from '../safetyAlert/SafetyAlert';
import { confirm } from 'devextreme/ui/dialog';
import ScrollView from 'devextreme-react/scroll-view';
import DateBox from 'devextreme-react/date-box';
import logoImg from '../safetyMsg/assets/noAttachment.png'
import corruptedImg from '../safetyMsg/assets/CORRUPTEDFILE.jpg';
import RadioGroup from 'devextreme-react/radio-group';
import pdfImg from '../safetyMsg/assets/pdfImg.png'
import pptImg from '../safetyMsg/assets/pptImg.png'
import excelImg from '../safetyMsg/assets/excelImg.png'
import wordImg from '../safetyMsg/assets/wordImg.png';
import { Toast } from 'devextreme-react/toast';
import moment from 'moment';
import { getTypeOfFile } from '../../../common/utils';

const initialState = { messages: [], alerts: [] }

export default ({ siteId, tierId, data, widgetId, isEditable, expandIcon }) => {

    const type = widgetId ? widgetId : 'communication'
    const basePath = window.location.origin;
    const [state, dispatch] = useReducer(dashboardReducer, initialState);
    const { messages, alerts } = state
    const [showMsgs, setMsgs] = useState(true)
    const [editView, setEditView] = useState(false)
    const [message, setMessage] = useState('');
    const [uploadedFile, setUploadedFile] = useState([]);
    const [activeAlert, setActiveAlert] = useState(false);
    const [showExportForm, showExport] = useState(false);
    const [sDate, setSDate] = useState(new Date());
    const [eDate, setEDate] = useState(new Date());
    const [exportFilter, setExportFilter] = useState(0)
    const [loading, setLoading] = useState(false)

    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: 'info',
        message: '',
    });

    const handleMsgDisplay = () => setMsgs(!showMsgs)
    const saveMsg = () => {
        let data = {
            "crud": "ALTER",
            "sitecode": siteId,
            "tierid": tierId,
            "safetymessage": message,
            "safetymessagefilepath": "",
            "sqdcp": type
        }
        actions.updateMessages(dispatch, data)
        setEditView(false)
    }

    const revertMsg = () => {
        setMessage('')
        setEditView(false)
    }

    const [show, setShow] = useState(false)



    const showInfo = (data) => {
        setActiveAlert(data)
        setShow(true)

    }



    const apiProps = `siteId=${siteId}&tierId=${tierId}&sqdcp=${type}`

    useEffect(() => {
        actions.getAlerts(dispatch, apiProps)

    }, [type])

    function onHiding() {
        setToastConfig({
            ...toastConfig,
            isVisible: false,
        });
    }
    const exportData = () => {
        actions.exportData('digitaltier/exportPostsDetails', 'Honeywell Communications', { siteId: siteId, tierId: tierId, widgetId: widgetId, isAll: exportFilter == 1 ? false : true, startDate: moment(sDate).format("DD/MM/YYYY"), endDate: moment(eDate).format("DD/MM/YYYY") })
        showExport(false)
    }


    const updateAlertInfo = (data) => {
        data.append('sitecode', siteId)
        data.append('tierId', tierId)
        data.append('archive', "N")
        data.append('alertType', type)
        setShow(false);
        setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: 'success',
            message: 'Post Edited Successfully!!'
        });
        actions.updateAlerts(dispatch, data, apiProps)
    }

    const delAlert = (data) => {
        confirm("Are you sure you want to delete this record?", "Confirm delete")
            .then((res) => {
                if (res) {
                    let formData = new FormData();
                    formData.append('id', data.id)
                    formData.append('sitecode', siteId)
                    formData.append('tierId', tierId)
                    formData.append('archive', "Y")
                    formData.append('alertType', type)
                    setToastConfig({
                        ...toastConfig,
                        isVisible: true,
                        type: 'success',
                        message: 'Post Deleted Successfully!!'
                    });
                    actions.updateAlerts(dispatch, formData, apiProps)
                }

            }
            );
    }

    const openFiles = (data) => {
        let url = basePath + '/docviewer/ViewDocument?ipath=' + data.imagePath
        window.open(url, "NEXUS", "config='toolbar=no,title=Nexus, menubar=no,scrollbars=no,resizable=no,location=no,directories=no,status=no,width=" + 900 + ",height=" + 600 + ",top=" + 500 + ",left=" + 200 + "'");
    };

    const apiDetails = `siteId=${siteId}&tierId=${tierId}&sqdcp=${type}&title=${data.title}`
    const getMessageDetails = (apiProps) => {
        actions.getMessages(dispatch, apiProps);
        setMessage('')
    }
    const getAlerts = () => {
        setLoading(true)
        actions.getAlerts(dispatch, apiDetails);
        getMessageDetails(apiDetails);
        setLoading(false)
    }

    const getThumbnail = (data) => {
        let fileType = data.fileExtension.toLowerCase();
        switch (fileType) {
            case 'gif':
            case 'png':
            case 'jfif':
            case 'jpg':
            case 'jpeg':
                return <img className="alert-img" src={data.fileStream} />
            case 'ppt':
            case 'pptx':
                return <img className="alert-img" src={pptImg} />
            case 'pdf':
                return <img className="alert-img" src={pdfImg} />
            case 'excel':
            case 'xlsx':
            case 'csv':
            case 'xls':
            case 'xlt':
            case 'xltm':
                return <img className="alert-img" src={excelImg} />
            default:
                return <img className="alert-img" src={logoImg} />
        }
    }

            //case 'doc':
            //case 'docx':
            //    return <img className="alert-img" src={wordImg} />
    const alertConfig = {
        hideInfo: () => setShow(false),
        show: show,
        showInfo: showInfo,
        updateAlertInfo: updateAlertInfo,
        tpl: data,
        activeAlert: activeAlert,
        popupTitle: "Communications/Recognition",
        getCall: getAlerts
    }

    return (
        <div  style={{ position: "relative" }} className="communications-container" >
            <div className="create-posts m-w-572" style={alerts.length < 1 ? { top: "-67px" } : {}}>
                {(alerts.length > 0 && !showExportForm) && <span onClick={() => { showExport(!showExportForm) }}><i className="fas fa-file-export"></i>{expandIcon != "fa-expand" ? <span>Export</span> : ''}</span>}
                {isEditable && <span onClick={() => { setShow(true); setActiveAlert(null) }}><i className="fas fa-plus"></i>{expandIcon != "fa-expand"? <span> Create post</span> : ''}</span>}
            </div>
            {showExportForm && <div className="m-w-572 ">
                <div >
                    <RadioGroup items={[{ id: 0, text: 'All' }, { id: 1, text: 'Date range' }]} value={exportFilter}
                        valueExpr="id" displayExpr="text" onValueChanged={e => setExportFilter(e.value)} layout="horizontal" />
                </div>
                {(exportFilter == 1) && <div className="alert-container"><span>Start date: <DateBox value={sDate} onValueChanged={e => setSDate(e.value)} useMaskBehavior={true}
                    type="date"
                /></span><span>End date: <DateBox value={eDate} onValueChanged={e => setEDate(e.value)} type="date" useMaskBehavior={true} /></span></div>

                }
                <div className="cbtn"><button onClick={exportData} className="btn secondary-btn">Export</button><button onClick={() => { showExport(!showExportForm) }} className="btn primary-btn">Cancel</button></div >
            </div>
            }
            {loading ? < div className="no-data-fnd max-w-572" >Loading...</div> : ''}
            {!loading && alerts.length > 0 &&
                <ScrollView id="sitecontent"
                    {...{
                        showScrollbar: 'always',
                        scrollByContent: true,
                        scrollByThumb: true,
                    }}
                >
                    <div className="posts-scroll-view">
                        <div className="people-flex-container ">
                            { alerts.map((data, i) => {
                                   return  <div key={i} className="people-posts-card">
                                        <div className="alert-container" >
                                            <div className="posts-img">
                                                {
                                                    
                                                        (data.imageName === "CORRUPTED")
                                                            ? <a title="Corrupted File" className="no-link" disabled>
                                                                {
                                                                    getThumbnail(data)
                                                                }
                                                            </a>
                                                       : (data.fileExtension ? <a onClick={() => {
                                                           data.fileExtension = data.fileExtension == 'xls' ? 'xlsx' : data.fileExtension
                                                           getTypeOfFile(data, 'Sites')
                                                       }}>
                                                           {
                                                               getThumbnail(data)
                                                           }
                                                       </a> : < a title="No Attachment" className="no-link" disabled>
                                                           {
                                                               getThumbnail(data)
                                                           }
                                                       </a>)                                                      
                                                }
                                            </div>
                                            <div className="posts-desc">

                                                <h4 className="pd-top-10">{data.messageTitle}</h4>
                                                <div className="pd-top-10">Posted Date: {data.createdDate}</div>
                                                <div className="pd-top-10 communication-description"> {data.messageDescription}</div>

                                            </div>
                                            <div className="actions">
                                                {isEditable && <> <i className="fas fa-pencil-alt" title="Edit Alert" onClick={() => showInfo(data)}></i>
                                                    <i title="Delete Alert" className="fas fa-trash" onClick={() => delAlert(data)} ></i></>}
                                            </div>
                                        </div>
                                    </div>
                                }
                                )
                            }
                        </div>
                    </div>
                </ScrollView>
            }
            {!loading && alerts.length < 1 && <div className="no-data-fnd max-w-572" >No Posts</div>}

            <SafetyAlert {...alertConfig} />
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={onHiding}
                displayTime={2000}
            />
        </div>
    )
}